import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IChangePaymentSystemPayload } from '../types';
import {
  ADMIN_CHANGE_PAYMENT_SYSTEM_MUTATION_KEY,
  ADMIN_CREATE_PAYMENT_SYSTEM_API_URL,
  ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_QUERY_KEY,
  ADMIN_PAYMENT_SYSTEM_DETAILS_SHOW_QUERY_KEY,
  PAYMENT_SYSTEM_DETAILS_PERMISSIONS,
} from '../constants';

export default function useAdminChangePaymentSystemMutation(): IContextMutationResult<void, Error, IChangePaymentSystemPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IChangePaymentSystemPayload>({
    mutationKey: [ADMIN_CHANGE_PAYMENT_SYSTEM_MUTATION_KEY],
    mutationFn: ({ id, ...payload }) => fetchPost<void>(
      ADMIN_CREATE_PAYMENT_SYSTEM_API_URL,
      payload,
      {
        permission: PAYMENT_SYSTEM_DETAILS_PERMISSIONS.EDIT_PAYMENT_METHOD,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [ADMIN_PAYMENT_SYSTEM_DETAILS_SHOW_QUERY_KEY] });
      await queryClient.invalidateQueries({ queryKey: [ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
